"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITiledEmbeddedCollectionOfImagesTileset = void 0;
const zod_1 = require("zod");
const ITiledMapEmbeddedTileset_1 = require("./ITiledMapEmbeddedTileset");
const ITiledMapTileWithImage_1 = require("./ITiledMapTileWithImage");
exports.ITiledEmbeddedCollectionOfImagesTileset = ITiledMapEmbeddedTileset_1.ITiledMapEmbeddedTileset.omit({
    image: true,
    tiles: true,
}).and(zod_1.z.object({
    tiles: zod_1.z.array(ITiledMapTileWithImage_1.ITiledMapTileWithImage).optional(),
}));
//# sourceMappingURL=ITiledMapEmbeddedCollectionOfImagesTileset.js.map